import { Record } from 'immutable';

export const Rma = new Record({
  id: null,
  rma_number: null,
  status: null,
  legacy_incoming_iccid: null,
  legacy_new_iccid: null,
  legacy_replaced_iccid: null,
  hidden_comments: null,
  comments: null,
  input_time: null,
  update_time: null,
  shipping_date: null,
  received_date: null,
  invoiced_time: null,
  tracking_number: null,
  shipping_cost: null,
  handling_cost: null,
  model: null,
  arrival_firmware_version: null,
  resolution: null,
  unauthorized_swap: null,
  total_cost: null,
  picture: null,
  control_number: null,
  initial_test_results: null,
  input_user: null,
  invoiced_user: null,
  issue: null,
  received_user: null,
  shipping_cost_included_on_rma_id: null, // another rma id?
  shipping_user_id: null,
  site_group_id: null,
  update_user_id: null,
  warranty_fee_id: null,
  warranty_status_id: null,
  inbound_shipping_mode: null,
  outbound_shipping_mode: null,
  picture_upload_time: null,
  is_quick_ship: null,
  picture_upload_user: null,
  old_shipping_cost_value: null,
  support_ticket_id: null,
  site_id: null,
  billing_address: null,
  shipping_address: null,
  contact: null,
  phone: null,
  // New inline shipping fields
  ship_contact: null,
  ship_email: null,
  ship_phone: null,
  ship_country: null,
  ship_address: null,
  ship_city: null,
  ship_state: null,
  ship_zip: null,
  ship_instructions: null,
  // New inline billing fields
  bill_contact: null,
  bill_email: null,
  bill_phone: null,
  bill_country: null,
  bill_address: null,
  bill_city: null,
  bill_state: null,
  bill_zip: null,
  radio_returned_by_user: null,
  radio_shipped_to_user: null,
  canceled: null,
});
